import styled from "@emotion/styled";
import { LinkButton } from "../../Common/Link";
import { Button, Divider } from "@mui/material";
import ToggleButton from "@mui/material/ToggleButton";

interface AddModificationStylesProps {
	multipleRanges: boolean;
}

export const AddModificationButton = styled(Button)({
	display: "flex",
	fontSize: "0.9rem",
	gap: "8px",
	fontWeight: 500,
	textTransform: "uppercase"
});

export const AddModificationTypeWrapper = styled.div<AddModificationStylesProps>(({ multipleRanges, theme }) => ({
	display: "flex",
	flexDirection: "row",
	gap: 16,
	width: "100%",
	"& > div": {
		width: "100%"
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column"
	}
}));

export const ModificationGroup = styled.div(({ theme }) => ({
	alignItems: "flex-start",
	display: "flex",
	flexDirection: "column",
	gap: 16,
	"& > div": {
		width: "100%"
	},
	"& > h6": {
		...theme.project.typography.heading.h6,
		color: theme.project.colors.fontColors.main,
		margin: 0
	},
	width: "100%"
}));

export const CQModificationHeader = styled.h6({
	marginTop: "16px !important"
});

export const ModificationSkeletonContainer = styled.div({
	marginBottom: 8
});

export const StyledToggleButton = styled(ToggleButton)({
	width: 24,
	height: 24
});

export const AddModificationRemoveButton = styled(LinkButton)(({ theme }) => ({
	height: 40,
	[theme.breakpoints.down("md")]: {
		alignSelf: "center",
		height: "auto"
	}
}));

export const AddModificationValues = styled.div(({ theme }) => ({
	...theme.project.typography.caption,
	color: theme.project.colors.fontColors.secondary,
	paddingTop: 3
}));

export const AddModificationButtonContainer = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	gap: 4,
	alignItems: "center",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column"
	}
}));

export const AddModificationButtonCaption = styled.div(({ theme }) => ({
	...theme.project.typography.caption,
	color: theme.project.colors.fontColors.secondary
}));

export const StyledDivider = styled(Divider)({
	width: "100%"
});
